class SaveSearch {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("saveSearch", () => ({
                    locResult: {},

                    init() {
                        window.alpineRender(this);
                    },

                    openDialogSaveSearch(element) {
                        if (element.ariaDisabled === "true") {
                            return;
                        }
                        const dialog = document.querySelector(
                            `[x-ref='dialogSaveSearch']`,
                        );

                        if (dialog && !dialog.open) {
                            dialog.showModal();
                        }

                        if (
                            !window.CONFIG.connected ||
                            this.getSavedSearch ||
                            this.totalSave >= this.maxSave
                        ) {
                            return;
                        }

                        this.updateSearches();
                    },

                    get getLabel() {
                        let label = this.locResult.title;

                        if (this.locResult.adminCode) {
                            label += ` (${this.locResult.adminCode})`;
                        }

                        if (this.listResult.params.distance >= 0) {
                            label += ` · ${this.listResult.params.distance} km`;
                        }

                        return label;
                    },

                    updateSearches(email = false, element = null) {
                        if (element && element.ariaDisabled === "true") {
                            return;
                        }
                        this.stateSaveSearch = this.LOADING;

                        // Pas de période en recherche enregistré
                        const params = { ...this.listResult.params };
                        this.applyAliasToParams(params);

                        delete params.min;
                        delete params.max;

                        window.useHttpApi
                            .put(
                                "/v1/search",
                                {
                                    label: this.getLabel,
                                    email,
                                    push: false,
                                    params,
                                    agenda: window.CONFIG.agenda.id,
                                },
                                { extra: { dialog: true } },
                            )
                            .then((res) => {
                                if (this.getSavedSearch) {
                                    const oldIndex = this.searches.findIndex(
                                        (search) =>
                                            search.hash ===
                                            this.listResult.hash,
                                    );
                                    this.searches[oldIndex] = res["body"];
                                } else {
                                    this.searches.push(res["body"]);
                                    this.totalSave += 1;
                                }
                                this.getSavedSearch = res["body"];
                                this.stateSaveSearch = null;
                            })
                            .catch(() => {
                                this.stateSaveSearch = this.ERROR;
                            });
                    },
                    applyAliasToParams(params) {
                        const alias = this.getAliasFromUrl();

                        if (alias === "weekends") {
                            params.min = null;
                            params.max = null;
                            params.days = [6, 0];
                            return;
                        }
                    },
                    getAliasFromUrl() {
                        const path = window.location.pathname
                            .split("/")
                            .filter(Boolean);
                        return path[path.length - 1]?.toLowerCase() ?? null;
                    },
                }));
            },
            { once: true },
        );
    }
}

new SaveSearch();
